enum PriceComparisonAlertRuleTrigger {
    INSIDE_PRICE_RANGE = "INSIDE_PRICE_RANGE",
    OUTSIDE_PRICE_RANGE = "OUTSIDE_PRICE_RANGE",
}

export default PriceComparisonAlertRuleTrigger;